export default "__VITE_ASSET__c2cd546e__"